<template>
	<GlassCard class="trivia p-3">
		<h3>Did you know?</h3>
		<!-- <p>{{ trivia }}</p> -->
		<markdown :source="trivia" v-if="trivia" />
	</GlassCard>
</template>

<script setup>
	import { ref, onMounted } from "vue"
	import Markdown from "./Markdown.vue"
	import GlassCard from "./GlassCard.vue"

	const trivia = ref(null)

	const fetchTrivia = async () => {
		try {
			const response = await fetch("/api/trivia")
			const data = await response.json()
			trivia.value = data.trivia
		} catch (error) {
			console.error("Failed to fetch trivia:", error)
		}
	}

	const setHourlyTriviaUpdate = () => {
		// Calculate the time until the next hour
		const now = new Date()
		const nextHour = new Date(
			now.getFullYear(),
			now.getMonth(),
			now.getDate(),
			now.getHours() + 1,
			1,
			0,
			0
		)
		const timeUntilNextHour = nextHour - now

		// Set a timeout to fetch trivia at the next hour
		setTimeout(() => {
			fetchTrivia()
			// Set an interval to fetch trivia every hour on the hour
			setInterval(fetchTrivia, 3600000) // 3600000 ms = 1 hour
		}, timeUntilNextHour)
	}

	onMounted(() => {
		fetchTrivia()
		setHourlyTriviaUpdate()
	})
</script>

<style scoped>
	.trivia {
		margin: 20px 0;
		padding: 10px;
	}

	.trivia p {
		margin: 0.5em 0 0;
		font-size: 1em;
		color: #555;
	}
</style>
